import { ICollectionMapper } from '../Firestore/ICollectionMapper'
import { Reminder, IReminder } from './Reminder'

export class ReminderMapper implements ICollectionMapper<Reminder> {
  map(data: IReminder): Reminder {
    const reminder = new Reminder(data.text, data.vendorCompanyId, data.restaurantCompanyId, data.priceListEntryId)
    reminder.id = data.id

    return reminder
  }

  serialize(object: Reminder): IReminder {
    return JSON.parse(JSON.stringify(object))
  }
}
